export function padSuspectParameterName(suspectParameterName) {
  return suspectParameterName.padStart(6, '0')
}

export function padFailureModeIndicator(failureModeIndicator) {
  return failureModeIndicator.padStart(2, '0')
}
